module.exports = __webpack_public_path__ + "static/media/icons_school_bus.f10d9ec6.jpeg";